
export const isBoolean = (obj) => {
  return typeof obj === 'boolean'
}
export const isNumber = (obj) => {
  return typeof obj === 'number' && !isNaN(obj)
}
export const isString = (obj) => {
  return typeof obj === 'string'
}
export const isInteger = function (obj) {
  return (obj | 0) === obj
}
export const isUndefinedOrNull = function (obj) {
  return obj === undefined || obj === null
}
export const isNoValue = function (obj) {
  return obj === undefined || obj === null || obj === ''
}
export const getTime = (date) => {
  if (date === null) return
  date = new Date(date)
  if (date.toString() === 'Invalid Date') return
  let hour = date.getHours()
  let min = date.getMinutes()
  hour = hour > 9 ? hour : `0${hour}`
  min = min > 9 ? min : `0${min}`
  return `${hour}:${min}`
}
export const formatDateTime = (date) => {
  var time = new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  return time
}
// 格式化日期
export const formatDate = (date) => {
  if (date === null) return
  date = new Date(date)
  if (date.toString() === 'Invalid Date') return
  let m = (date.getMonth() + 1).toString()
  let d = date.getDate().toString()
  m = m.length >= 2 ? m : '0' + m
  d = d.length >= 2 ? d : '0' + d
  return date.getFullYear() + '-' + m + '-' + d
}
export const isValidDate = (date) => {
  if (date === null) return false
  date = new Date(date)
  return date.toString() !== 'Invalid Date'
}
export const formatDateAndTime = (date) => {
  if (date === null) return
  date = new Date(date)
  if (date.toString() === 'Invalid Date') return
  const dateStr = formatDate(date)
  const timeStr = getTime(date)
  return `${dateStr} ${timeStr}`
}
export const setTimeToDate = (timeStr, date) => {
  date = new Date(date)
  if (date.toString() === 'Invalid Date') return
  timeStr = timeStr.split(':')
  date.setHours(parseInt(timeStr[0]))
  date.setMinutes(parseInt(timeStr[1]))
  return date
}

export const isEmptyObj = (obj) => {
  for (let obj1 in obj) {
    return false
  }
  return true
}

// 除法
export const accDiv = (arg1, arg2) => {
  let t1 = 0
  let t2 = 0
  let r1, r2
  try { t1 = arg1.toString().split('.')[1].length } catch (e) {}
  try { t2 = arg2.toString().split('.')[1].length } catch (e) {}
  r1 = Number(arg1.toString().replace('.', ''))
  r2 = Number(arg2.toString().replace('.', ''))
  return accMul((r1 / r2), Math.pow(10, t2 - t1))
}

// 乘法
export const accMul = (arg1, arg2) => {
  let m = 0
  let s1 = arg1.toString()
  let s2 = arg2.toString()
  try { m += s1.split('.')[1].length } catch (e) {}
  try { m += s2.split('.')[1].length } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 加法
export const accAdd = (arg1, arg2) => {
  let r1, r2, m
  try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 减法
export const accSub = (arg1, arg2) => {
  let r1, r2, m, n
  try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

// 将一维数组转换为二维数组
export const transferTo2DArray = function (arr, col) {
  let arr2 = []
  let row = Math.ceil(arr.length / col)
  for (let i = 0; i < row; i++) {
    arr2[i] = []
    for (let j = 0; j < col; j++) {
      if (arr[i * col + j]) {
        arr2[i][j] = arr[i * col + j]
      }
    }
  }
  return arr2
}

export const genID = (randomLength = 6) => {
  return Number(Math.random().toString().substr(3, randomLength) + Date.now()).toString(36)
}

export const maskStr = (str, start, end, char = '*') => {
  if (typeof str !== 'string') return
  let len = str.length - start - end
  let xing = ''
  for (let i = 0; i < len; i++) {
    xing += char
  }
  return str.substring(0, start) + xing + str.substring(str.length - end)
}

export const msToTime = (ms, keepHour = true, useCH = false) => {
  let t = ''
  let s = Math.round(ms / 1000)
  if (s > 0) {
    let hour = Math.floor(s / 3600)
    let min = Math.floor(s / 60) % 60
    let sec = s % 60
    let split = useCH ? ['时', '分', '秒'] : new Array(2).fill(':')
    if (hour < 10) {
      if (keepHour || t > 0) {
        t += '0' + hour + split[0]
      }
    } else {
      t += hour + split[0]
    }

    if (min < 10 && min >= 0) { t += '0' }
    t += min + split[1]
    if (sec < 10 && sec >= 0) { t += '0' }
    t += sec + (useCH ? split[2] : '')
    return t
  } else {
    return '00:00:00'
  }
}

export const loadJS = (url) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error('a js url is required'))
    } else {
      $.getScript(url)
        .done(function (script, textStatus) {
          resolve()
        })
        .fail(function (jqxhr, settings, exception) {
          console.log(exception)
          reject(new Error('load js fail, src is:' + url))
        })
    }
  })
}

export const loadCSS = (url) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error('a css url is required'))
    } else {
      $('<link>')
        .attr({ rel: 'stylesheet',
          type: 'text/css',
          href: url
        })
        .appendTo('head')
      resolve()
    }
  })
}

export const calcPercent = (val, totalVal) => {
  if (totalVal === 0) return 0
  return parseFloat(accMul(val / totalVal, 100).toFixed(2))
}

export const checkPasswordStrength = (pw, oldPw) => {
  let result = {
    strength: 0,
    tooShort: false,
    invalid: false,
    samePassword: false,
    tooShortText: '密码长度需大于等于6位',
    invalidText: '密码只能由字母、数字、下划线和减号组成',
    samePasswordText: '与原密码相同'
  }
  if (oldPw && pw === oldPw) {
    result.samePassword = true
    return result
  }
  if (pw.length < 6) {
    result.tooShort = true
    return result
  }
  if (!/^[a-zA-Z0-9_-]+$/.test(pw)) {
    result.invalid = true
    return result
  }
  if (/[0-9]/.test(pw)) result.strength++ // 数字
  if (/[a-z]/.test(pw)) result.strength++ // 小写
  if (/[A-Z]/.test(pw)) result.strength++ // 大写
  if (/_|-/.test(pw)) result.strength++ // 下划线和减号
  return result
}

export const isLocalStorageSupport = () => {
  var storageType = 'localStorage'
  try {
    var supported = (storageType in window && window[storageType] !== null)

    // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
    // is available, but trying to call .setItem throws an exception.
    //
    // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
    // that exceeded the quota."
    var key = '__' + Math.round(Math.random() * 1e7)
    if (supported) {
      var webStorage = window[storageType]
      webStorage.setItem(key, '')
      webStorage.removeItem(key)
    }
    return supported
  } catch (e) {
    return false
  }
}

// 根据开始时间和结束时间，判断课程或章节是否开放，并返回对应状态和提示文本
export const getDisabledStatus = (_start, _end) => {
  const start = new Date(_start)
  const end = new Date(_end)
  const cur = Date.now()
  const isStartValid = isValidDate(start)
  const isEndValid = isValidDate(end)
  let result = {
    disabled: false,
    text: '',
    startAndEndValid: false,
    startValid: false,
    endValid: false
  }
  if (isStartValid && isEndValid) {
    result.disabled = cur < start.getTime() || cur > end.getTime()
    result.text = `于 <span class="text-danger">${formatDateAndTime(start)}</span> 至 <span class="text-danger">${formatDateAndTime(end)}</span> 开放`
    result.startAndEndValid = true
  } else if (isStartValid) {
    result.disabled = cur < start.getTime()
    result.text = `于 <span class="text-danger">${formatDateAndTime(start)}</span> 后开放`
    result.startValid = true
  } else if (isEndValid) {
    result.disabled = cur > end.getTime()
    result.text = `于 <span class="text-danger">${formatDateAndTime(end)}</span> 后结束`
    result.endValid = true
  } else {
    result.disabled = false
    result.text = ''
  }
  return result
}

export const formatPrice = (price) => {
  if (isNumber(price)) {
    return `￥${price.toFixed(2)}`
  }
}
export function toThousandslsFilter (num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}



// WEBPACK FOOTER //
// ./src/utils/util.js